import type { ReactNode } from "react";
import styles from "./Navbar.module.css";

export type NavbarProps = {
  brand: ReactNode;
  sectionLabel?: ReactNode;
  rightActions?: ReactNode;
  avatar?: ReactNode;
};

export const Navbar = ({ brand, sectionLabel, rightActions, avatar }: NavbarProps) => (
  <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
    <div className="container-fluid">
      <div className="d-flex align-items-center">
        <span className="navbar-brand mb-0 me-0">{brand}</span>
        {sectionLabel && <div className="app-section-label">{sectionLabel}</div>}
      </div>
      <ul className="navbar-nav ms-auto align-items-center gap-2 flex-row">
        {rightActions}
        {avatar && (
          <li className={`nav-item d-flex align-items-center ms-2 ${styles.avatarSlot}`}>
            {avatar}
          </li>
        )}
      </ul>
    </div>
  </nav>
);
